<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-italic`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M29.602 10l-7.104 28H31a1 1 0 011 1v2a1 1 0 01-1 1H10a1 1 0 01-1-1v-2a1 1 0 011-1h8.407l7.103-28H17a1 1 0 01-1-1V7a1 1 0 011-1h21a1 1 0 011 1v2a1 1 0 01-1 1h-8.398z"/></svg>
</template>
<script>

export default {
  name: 'IconItalic',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
